__turbopack_context__.v({
  "TitledCard": "TitledCard-module__NSpLNq__TitledCard",
  "title": "TitledCard-module__NSpLNq__title",
  "value": "TitledCard-module__NSpLNq__value",
});
